import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteMoneyPage as DeleteMoneyPageMutation,
    DeleteMoneyPageVariables,
    UrlDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_MONEY_PAGE from '../mutations/delete-money-page.graphql';
import GET_MONEY_PAGES from '../queries/get-money-pages.graphql';

import {GET_MONEY_PAGES_LIMIT} from './use-get-money-pages';

export const useDeleteMoneyPage = (): {
    deleteMoneyPage: (arg1: UrlDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteMoneyPage, {loading, error}] = useMutation<
        DeleteMoneyPageMutation,
        DeleteMoneyPageVariables
    >(DELETE_MONEY_PAGE);

    return {
        deleteMoneyPage: (input: UrlDeleteInput) =>
            deleteMoneyPage({
                variables: {input},
                update: (proxy) => {
                    const cacheResult = proxy.readQuery({
                        query: GET_MONEY_PAGES,
                        variables: {first: GET_MONEY_PAGES_LIMIT},
                    });

                    // @ts-expect-error
                    if (!cacheResult || !cacheResult.maUrls) return;

                    // @ts-expect-error
                    const newEdges = cacheResult.maUrls.edges.filter(
                        // @ts-expect-error
                        (edge) => edge.node.id !== input.id
                    );

                    proxy.writeQuery({
                        query: GET_MONEY_PAGES,
                        variables: {first: GET_MONEY_PAGES_LIMIT},
                        data: {
                            maUrls: {
                                // @ts-expect-error
                                ...cacheResult.maUrls,
                                // @ts-expect-error
                                totalCount: cacheResult.maUrls.totalCount - 1,
                                edges: newEdges,
                            },
                        },
                    });
                },
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
